import { memo, useCallback } from "react";
import {
  sanitizeAmount,
  isValidDecimal,
  formatNumberWithComma,
} from "../../utils/numberFormatter";

const NumberInDecimals = ({
  value = "",
  onChange,
  decimals = 3,
  max,
  disabled = false,
  className = "",
  ...props
}) => {
  const handleChange = useCallback(
    (e) => {
      let raw = sanitizeAmount(e.target.value);

      // allow ".", "" while typing
      if (raw === "" || raw === ".") {
        onChange(raw);
        return;
      }

      if (!isValidDecimal(raw, decimals)) return;

      let numeric = parseFloat(raw);

      // apply max constraint if provided
      if (max !== undefined && numeric > max) {
        raw = String(max);
      }

      onChange(raw);
    },
    [onChange, decimals, max],
  );

  return (
    <input
      {...props}
      type="text"
      disabled={disabled}
      className={className}
      value={formatNumberWithComma(value)}
      onChange={handleChange}
    />
  );
};

export default memo(NumberInDecimals);
